/**
 * Redux Store Configuration
 *
 * This module configures the global Redux store using Redux Toolkit.
 * It combines all the application's reducers into a single store that provides
 * state management across the entire application.
 *
 * The store is organized by feature slices, each responsible for a specific
 * domain of the application state.
 */

import { configureStore } from "@reduxjs/toolkit";

// Import individual feature slices
import authSlice from "./slices/auth"; // Authentication state
import tagsSlice from "./slices/tags"; // Tags management
import missingInfoSlice from "./slices/missingInfo"; // Missing information tracking
import integrationsInfoSlice from "./slices/integrationsInfo"; // Integration status
import performanceReportQueryParamsSlice from "./slices/performanceReportQueryParams"; // Report parameters
import countryOptionsSlice from "./slices/countryOptions"; // Countries for dropdowns

/**
 * Configure and create the Redux store
 *
 * @property {Object} reducer - Combined reducers object with named slices
 */
export const store = configureStore({
  reducer: {
    auth: authSlice, // User authentication state
    tags: tagsSlice, // Tags for categorization
    integrationsInfo: integrationsInfoSlice, // Integration state and configurations
    missingInfo: missingInfoSlice, // Tracking of missing required information
    performanceReportQueryParams: performanceReportQueryParamsSlice, // Report parameters
    countryOptions: countryOptionsSlice // Countries for dropdowns
  }
});
